<template>
  <div class="content">
    <form class="filter-form" v-if="showFilters">
      <div class="form-row">
        <div
          class="form-group col-md-2"
          v-for="(value, filter) in filters"
          v-bind:class="{'col-lg-3': filterLabels[filter]==='Financial company (alias)', 'col-md-4': filterLabels[filter]==='Financial company (alias)'}"
          v-bind:key="filter">
          <label>{{ filterLabels[filter] }}</label>
          <div v-if="DDL[filter]">
            <v-select
              label="name"
              key="id"
              :options="DDL[filter]"
              v-model="filters[filter]"
              :reduce="option => option.id"
              :multiple="true"
              :clearSearchOnSelect="true"
              :closeOnSelect="false"
              :clearable="true"
            ></v-select>
          </div>
          <div v-else>
            <b-input v-if="filter.indexOf('date_') === 0" type="date" v-model="filters[filter]"/>
            <b-input v-else type="text" v-model="filters[filter]"/>
          </div>
        </div>
      </div>
      <div class="btn-group">
        <div class="btn-group mr-2">
          <b-button @click="filter" variant="primary" type="button">Filter</b-button>
        </div>
        <div class="btn-group mr-2">
          <b-button @click="resetFilter" variant="warning" type="button">Reset filter</b-button>
        </div>
        <div class="btn-group mr-2">
          <b-button variant="success"
                    type="button"
                    :to="{ path: `/deal/`}">
            Add deal</b-button>
        </div>
      </div>
    </form>

    <div class="table-container">
      <div v-if="loading" style="text-align: center">
        <b-spinner style="text-align: center" variant="primary" label="Loading..."></b-spinner>
      </div>


      <b-table
        v-else
        class="table-scroll"
        :items="data"
        :fields="tableFields"
        striped
        no-local-sorting
        @sort-changed="sort"
      >
        <template v-slot:cell(external_account)="row">
          {{ row.item.external_account ? row.item.external_account.alias : 'NOT FOUND!' }}
          {{ row.item.external_account ? '(id: ' + row.item.external_account.id + ')' : '' }}
        </template>
        <template v-slot:cell(countries)="row">
          <template v-for="(broker, key) in row.item.countries">
            <div>
              <b>{{ data[row.index].brokers[key] + ` (id: ${key})` || key }}</b>
              <ul v-for="country in broker">
                <li>
                  <code>{{ country.name }}<span v-if="country.p1.length ">({{ country.p1.join(', ') }})</span></code>. CRG {{ country.crg }}%<br/>
                </li>
              </ul>
            </div>
          </template>
        </template>
        <template v-slot:cell(validity_period)="row">
          {{ row.item.date_from }} - {{ row.item.date_to }}
        </template>
        <template v-slot:cell(status)="row">
          {{ row.item.status.name }}
        </template>
        <template v-slot:cell(weekend)="row">
          {{ row.item.weekend === 1 ? 'Excluded' : 'Not excluded' }}
        </template>
        <template v-slot:cell(actions)="row">
          <div class="btn-group">
            <div class="btn-group mr-2">
              <b-button class="btn btn-primary btn-sm"
                        v-if="row.item.status.id !== 2"
                        :to="{ path: `/deal/${row.item.id}`, query: getQueryParams()}"
              >Edit</b-button>
            </div>
          </div>
        </template>
      </b-table>
    </div>
    <b-pagination
      v-model="currentPage"
      :total-rows="totalRows"
      :per-page="perPage"
      class="mt-4"/>
    <b-select class="col-md-2" id="per-page-input" v-model="perPage" :options="perPageConfig"/>
  </div>
</template>


<style lang="scss" scoped>
  /deep/ .vs__dropdown-option--selected {
    display: none;
  }
</style>

<script>
import API from '../api/Api'
import vSelect from 'vue-select'

export default {
  components: {
    vSelect,
  },

  data: () => ({
    loading: false,
    entityName: 'Deal',
    data: [],
    tableFields: [
      {
        key: 'name',
        sortable: false,
        label: 'Name',
      },
      {
        key: 'external_account',
        sortable: false,
        label: 'Financial company (alias)',
      },
      {
        key: 'countries',
        sortable: false,
        label: 'Countries',
      },
      {
        key: 'status',
        sortable: false,
        name: 'Status',
      },
      {
        key: 'weekend',
        sortable: false,
        name: 'Weekend',
      },
      {
        key: 'actions',
        sortable: false,
        label: 'Actions',
      },
    ],

    sortTable: {
      id: -1
    },

    itemToShow: {},

    showFilters: false,
    filters: {
      name: null,
      country_iso: null,
      external_account: null,
      status: [1]
    },

    operationTitle: null,

    filterLabels: {
      name: 'Deal name',
      country_iso: 'Country',
      external_account: 'Financial company (alias)',
      status: 'Status'
    },

    DDL: {
      'weekends': [
        {id: 1, name: 'Exclude weekends'},
        {id: 0, name: 'All week'},
      ]
    },

    editDealMode: false,
    entity: {},
    formErrors: {
      name: {state: false, message: null},
      external_account: {state: false, message: null},
      weekend: {state: false, message: null},
      crg: {state: false, message: null},
      date_from: {state: false, message: null},
      date_to: {state: false, message: null},
      countries: {state: false, message: null},
    },

    currentPage: 1,
    perPage: Number(window.localStorage.getItem('per-page')) || 10,
    totalRows: 0,
    perPageConfig: [
      {value: 10, text: "Per page: 10"},
      {value: 20, text: "Per page: 20"},
      {value: 30, text: "Per page: 30"},
      {value: 50, text: "Per page: 50"},
      {value: 100, text: "Per page: 100"},
    ],

    baseEntity: {
      name: "",
      external_account_id: null,
      weekend: false,
      countries: {},
    },
    removeID: null,
  }),

  mounted: async function () {
    await this.loadDDL();
    this.loadData();
  },
  watch: {
    currentPage: function () {
      this.loadData();
    },

    perPage: function () {
      window.localStorage.setItem('per-page', this.perPage.toString());
      this.loadData();
    }
  },
  methods: {
    sort: function (ctx) {
      this.sortTable = {};
      this.sortTable[ctx.sortBy] = ctx.sortDesc ? -1 : 1;
      this.currentPage = 1;

      this.loadData();
    },

    filter: function () {
      this.currentPage = 1;
      this.loadData();
    },

    resetFilter: function () {
      for (const field in this.filters) {
        this.filters[field] = null;
        this.loadData();
      }
    },

    loadDDL() {
      Promise.all([
        API.get('/distribution/deals/countries').then(data => this.DDL['country_iso'] = data.data),
        API.get('/billing/dropdown/external-accounts').then(data => this.DDL['external_account'] = data.data.map(item => {
          return {
            id: item['key'],
            name: item['alias'] || item['name'] || item['key']
          }
        })),
        API.get('/distribution/deals/statuses').then(data => this.DDL['status'] = data.data),
      ]).then((data) => {
        this.showFilters = true;
      })
    },

    loadData: function () {
      this.loading = true;
      let sort = '';
      const sortColumn = Object.keys(this.sortTable).length ? Object.keys(this.sortTable)[0] : null;
      if (sortColumn) {
        const dir = this.sortTable[sortColumn] === -1 ? '-' : '';
        sort = `?sort=${dir}${sortColumn}`
      }

      API.post(`/distribution/deals/index?page=${this.currentPage}&per-page=${this.perPage}`, this.filters).then(data => {
        this.data = data.data;
        this.totalRows = Number(data.headers['x-pagination-total-count']) || 0;
      }).catch(e => this.error = e.message).finally(() => this.loading = false);
    },

    getQueryParams: function () {
      const query = {
        currentPage: this.currentPage,
        perPage: this.perPage
      }
      for (const [key, value] of Object.entries(this.filters)) {
        if (value) {
          query[key] = value;
        }
      }
      return query;
    }

  }
}
</script>
